export default __webpack_public_path__ + "static/media/Stones.87db9079.png";